/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './muteThread.defs'
export { main as default } from './muteThread.defs'
